<app-dialog-header
  [header]="'library.user_card.attributes.change_value.header' | translate"
  iconClass="icon-edit-icon"
>
</app-dialog-header>
<app-dialog-content [formGroup]="form">
  <div class="p-grid">
    <div class="p-col-12 text-uppercase align-center">
      {{ 'library.user_card.attributes.change_value.message' | translate }}:
      @if (attribute.displayNameKey) {
        {{ attribute.displayNameKey | translate }}
      }
      @if (!attribute.displayNameKey) {
        {{ attribute.displayName | default: '-' }}
      }
    </div>
  </div>
  <div class="form-control-container">
    <app-form-control-label [control]="form.get('value')">
      {{ 'library.user_card.attributes.change_value.input_label' | translate }}:
    </app-form-control-label>
    <input
      appInput
      data-qa="attirbute-value-input"
      formControlName="value"
    >
    <app-form-control-error [control]="form.get('value')"></app-form-control-error>
  </div>
</app-dialog-content>
<div class="dialog-footer">
  <button
    (click)="close()"
    data-qa="user-attribute-value-dialog-close-button"
    type="button"
    class="proget-button text-only"
  >
    {{ 'button.close.label' | translate }}
  </button>
  <button
    [submitButton]="form"
    (click)="submit(form)"
    data-qa="user-attribute-value-dialog-submit-button"
    type="button"
    class="proget-button text-only primary-button"
  >
    {{ 'button.submit.label' | translate }}
  </button>
</div>
